import _ from "lodash";
import React, { useContext } from "react";
import AppContext from "../../../AppContext";
import { PositiveIntegerNumberInput } from "../../../Components";
import {
  getCurrentOrder,
  getCurrentOrderCustomerPriceGroup,
  getDeliveryPeriodForEan,
  getEanForColorAndSize,
  getPriceFromCache,
} from "../../../selectors";
import {
  isEanInputDisabled,
  requiresMinQuantity,
} from "../../../utils/products";
import { Item } from "./Item";

export const Ean = ({
  product,
  onChange,
  getValue,
  color,
  length,
  size,
  isReadonly,
  deliveryDate,
  number,
  season,
}) => {
  const context = useContext(AppContext);
  const currentOrder = getCurrentOrder(context);
  const value = getValue({ size, length, color });
  const deliveryPeriodStatusData = getDeliveryPeriodForEan({
    number,
    context,
    color,
    size,
    deliveryPeriodId: deliveryDate,
  });

  const data = deliveryPeriodStatusData;
  const deliveryPeriodStatus = data?.v;

  const ean = getEanForColorAndSize({
    number,
    context,
    color,
    size,
  });

  const pg = getCurrentOrderCustomerPriceGroup(context);

  const price = getPriceFromCache({
    number,
    context,
    priceGroup: pg,
    season,
    ean,
  });

  const inputIsDisabled = isEanInputDisabled({
    deliveryPeriodStatus,
    value,
  });

  const onKeyUp = (e) => {
    const t = e.target;
    const ean = t.parentNode.parentNode;
    const row = ean.parentNode;
    const itemCount = row.children.length;
    const rows =
      row.parentNode.parentNode.parentNode.parentNode.querySelectorAll(
        ".eanrow",
      );
    const rowCount = rows.length;

    let moved = false;
    let colPosition = _.findIndex(row.children, ean);
    let rowPosition = _.findIndex(rows, row);

    if (e.which === 37) {
      // LEFT
      colPosition = Math.max(0, colPosition - 1);
      moved = true;
    }

    if (e.which === 38) {
      // UP
      rowPosition = Math.max(0, rowPosition - 1);
      moved = true;
    }

    if (e.which === 39) {
      // RIGHT
      colPosition = Math.min(itemCount - 1, colPosition + 1);
      moved = true;
    }
    if (e.which === 40) {
      // DOWN
      rowPosition = Math.min(rowCount - 1, rowPosition + 1);
      moved = true;
    }

    if (!moved) {
      return;
    }

    const selectedRow = rows[rowPosition];
    const input = selectedRow.children[colPosition].querySelector("input");

    input.focus();
    input.setSelectionRange(0, 0);
    // e.persist();
  };

  if (value && inputIsDisabled && !isReadonly) {
    onChange({
      value: 0,
      length,
      color,
      size,
    });
  }

  // Size E have a min quantity of 4
  let inputRef = "1";

  const orderType = currentOrder.doc.orderType.value;
  const minQuantityProduct = requiresMinQuantity(
    product.cluster,
    product.collection,
    [size],
    orderType,
  );

  const invalidValue = minQuantityProduct && value > 0 && value < 4;
  const hasPrice = _.get(price, "value");

  return (
    <Item
      deliverPeriod={deliveryPeriodStatus}
      isDisabled={isReadonly || inputIsDisabled}
      hasPrice={hasPrice}
    >
      <PositiveIntegerNumberInput
        disabled={isReadonly || inputIsDisabled}
        invalid={invalidValue}
        type="number"
        value={value || 0}
        inputRef={(x) => (inputRef = x)}
        onKeyUp={onKeyUp}
        onClick={() => {
          window.lastEntry = new Date();
          window.eanRef = inputRef;
        }}
        onChange={(_v) => {
          window.lastEntry = new Date();
          if (_v > 999) return;
          if (!isReadonly && !inputIsDisabled) {
            onChange({
              value: Number(_v),
              length,
              color,
              size,
            });
          }
        }}
      />
      <DeliverabilityInfo data={data} />
    </Item>
  );
};

function DeliverabilityInfo(props) {
  const data = props.data;
  if (data === undefined) {
    return null;
  }

  const status = data.v;
  const stock = `${status === 1 ? data.s : ""}`; // only show on yellow
  const color = deliverabilityColor(status);
  const textColor = deliverabilityTextColor(status);

  return (
    <div
      className="stock"
      style={{
        backgroundColor: color,
        color: textColor,
        minHeight: "16px",
        minWidth: "24px",
      }}
    >
      {stock}
    </div>
  );
}

function deliverabilityColor(status) {
  switch (status) {
    case 0:
      return "green";
    case 1:
      return "yellow";
    case 2:
      return "#b80f0a";
    default:
      return "black";
  }
}

function deliverabilityTextColor(status) {
  switch (status) {
    case 0:
      return "white";
    case 1:
      return "black";
    case 2:
      return "white";
    default:
      return "black";
  }
}
